/* lh-klaviyo-cart.js  (F1b full-cart tracker)
   Additive, read-only. Listens for theme:cart:change (dispatched by
   lh-cart-drawer.js on every successful add / quantity change), reads the
   full cart, and pushes a custom Klaviyo event "Cart Updated" whose
   line_items mirror Shopify's Checkout Started event.extra.line_items schema,
   so F1a's recap Liquid renders it unchanged (colour included).

   It never modifies the cart, DOM, drawer, Globo, the PDP add-guard, or
   checkout, and never touches the native "Added to Cart" event. */
(function lhKlaviyoCartTracker() {
  'use strict';

  var EVENT_NAME  = 'Cart Updated';   // MUST stay distinct from native "Added to Cart"
  var DEBOUNCE_MS = 500;
  var THUMB_WIDTH = 240;

  var timer = null;
  var latestDetailCart = null;
  var lastFingerprint = null;

  function noop() {}

  function centsToDollars(c) {
    return (typeof c === 'number' ? c : 0) / 100;
  }

  // ~240px CDN thumbnail (rendered at 50px), keeps the email light.
  function thumb(url) {
    if (!url || typeof url !== 'string') return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + THUMB_WIDTH;
  }

  // /cart.js properties are an object; F1a's Liquid loops a list of {name,value}.
  // Keep ALL keys (image-dropdown-1 colour, topcoat, _gpo_*, filler2, glue2, ...).
  function propsToList(props) {
    var out = [];
    if (!props) return out;
    if (Array.isArray(props)) {
      for (var i = 0; i < props.length; i++) {
        var p = props[i];
        if (p && typeof p === 'object' && 'name' in p) out.push({ name: p.name, value: p.value });
        else if (Array.isArray(p)) out.push({ name: p[0], value: p[1] });
      }
      return out;
    }
    var keys = Object.keys(props);
    for (var j = 0; j < keys.length; j++) out.push({ name: keys[j], value: props[keys[j]] });
    return out;
  }

  // /cart.js options_with_values (array) -> name->value dict, as F1a expects.
  function optionsToDict(opts) {
    var d = {};
    if (Array.isArray(opts)) {
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        if (o && typeof o === 'object' && 'name' in o) d[o.name] = o.value;
      }
    }
    return d;
  }

  // Map one /cart.js line item to the Checkout Started line-item schema.
  function mapLineItem(ci) {
    var img = thumb(ci.image); // /cart.js already resolves the per-variant image
    var cents = (ci.final_line_price != null) ? ci.final_line_price : ci.line_price;
    return {
      quantity: ci.quantity,
      variant_title: ci.variant_title,             // may be null / "Default Title"
      line_price: centsToDollars(cents),           // dollars (cents / 100)
      properties: propsToList(ci.properties),      // list of {name, value}
      product: {
        title: ci.product_title,                   // raw, incl. "ADD ..." prefixes
        images:  [ { thumb_src: img } ],           // normal-line image path
        variant: { images: [ { thumb_src: img } ] }, // ADD-line image path
        variant_options: optionsToDict(ci.options_with_values) // name->value dict
      }
    };
  }

  function buildPayload(cart) {
    return {
      '$value': centsToDollars(cart.total_price),  // dollars, for the Email 2 value split
      'currency': cart.currency,
      // Nested under "extra" so F1a's {% for item in event.extra.line_items %}
      // renders unchanged. If the preview is empty, rename this key to "$extra".
      'extra': { line_items: (cart.items || []).map(mapLineItem) }
    };
  }

  // Fingerprint changes when any line's variant, properties (Shopify line key
  // encodes properties), or quantity changes, or the total changes.
  function fingerprint(cart) {
    var parts = (cart.items || []).map(function (i) { return i.key + 'x' + i.quantity; });
    return parts.join(',') + '@' + cart.total_price;
  }

  function push(cart) {
    try {
      if (!cart || !cart.items || cart.items.length === 0) return; // ignore empty cart
      var fp = fingerprint(cart);
      if (fp === lastFingerprint) return;                          // de-dupe unchanged cart
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', EVENT_NAME, buildPayload(cart)]);
        lastFingerprint = fp;                                      // advance only on a real send
      }
    } catch (e) { /* fail silent */ }
  }

  function flush() {
    timer = null;
    var cart = latestDetailCart;
    latestDetailCart = null;
    if (cart && cart.items) { push(cart); return; }
    // Fallback: read the cart ourselves (GET, no mutation).
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(push)
      .catch(noop);
  }

  function onCartChange(e) {
    try {
      latestDetailCart = (e && e.detail && e.detail.cart) || null;
      if (timer) clearTimeout(timer);
      timer = setTimeout(flush, DEBOUNCE_MS);   // debounce bursts into one send
    } catch (err) { /* fail silent */ }
  }

  if (document && document.addEventListener) {
    document.addEventListener('theme:cart:change', onCartChange, false);
  }
})();